import Puzzle from './Puzzle';

export default Puzzle;
